const WineImageZoomLayer = ({ wine, isHovering, mousePosition }) => {
  if (!isHovering) {
    return null;
  }

  return (
    <>
      <div
        className="absolute inset-0 rounded-3xl pointer-events-none"
        style={{
          backgroundImage: `url(${wine.image})`,
          backgroundPosition: `${mousePosition.x}% ${mousePosition.y}%`,
          backgroundSize: '250%',
          backgroundRepeat: 'no-repeat',
        }}
      />
      <div
        className="absolute w-20 h-20 border-2 border-wine-gold/60 rounded-full pointer-events-none"
        style={{ left: `${mousePosition.x}%`, top: `${mousePosition.y}%`, transform: 'translate(-50%, -50%)' }}
      />
    </>
  );
};

export default WineImageZoomLayer;
